import React from 'react';
import model from './model';
import { SlotSchedule } from 'src/components/slotSchedule';

const Schedule = ({ prev, close, next }) => {
  return (
    <SlotSchedule
      onEndPrevious={prev}
      popupContainerStyle={{
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        padding: 0
      }}
      onDone={() => {
        model.emit('reload_schedule');
        next();
      }}
      hide={close}
    />
  );
};

export default Schedule;
